module.exports = __webpack_public_path__ + "img/posto-default.4ce2b72d.png";